import { cloneDeep as e } from "../../../../utils/cloneDeep.js";
import { ad2bs as t, bs2ad as n } from "../calendar-carburettor/converter/index.js";
import { zero_pad as r } from "../calendar-carburettor/zero-pad/index.js";
import { weeks as i } from "../calendar-engine/constants/calendar-date.js";
import { getStrategy as a } from "../core/libs/strategy/strategy-provider.js";
import { disableAfterMaxEngDate as o, selectCtx as s, selectEvents as c } from "../core/models/selectors/index.js";
import { useDatePickerStore as l } from "../core/models/use-date-picker-store.js";
import { Pipeline as u } from "../utilities/pipeline.js";
import { ModeEnum as d } from "../core/models/model.js";
import { Button as f } from "../../../button/index.js";
import { cn as p } from "../../../cn.js";
import { useMemo as m } from "react";
import { jsx as h, jsxs as g } from "react/jsx-runtime";
import { When as _ } from "react-if";
import v from "dayjs";
// src/design/forms/datepicker/ui/calendar-view.tsx
var y = (e) => s(e).isNepali ? i.ne : i.en, b = () => {
	let e = l(y);
	return /* @__PURE__ */ h("tr", {
		className: "p-0",
		children: e.map((e, t) => /* @__PURE__ */ h("td", {
			className: "p-1 text-center text-xs font-medium text-foreground",
			children: e[0]
		}, t))
	});
}, x = ({ onMonthClick: e, onYearClick: t }) => /* @__PURE__ */ g("div", {
	className: "flex px-1 py-1 w-full items-center justify-between border-b border-border",
	children: [
		/* @__PURE__ */ g("div", {
			className: "flex",
			children: [/* @__PURE__ */ h(S, {}), /* @__PURE__ */ h(C, {})]
		}),
		/* @__PURE__ */ g("div", {
			className: "flex flex-1  justify-center gap-1",
			children: [
				/* @__PURE__ */ h(E, { onSelection: e }),
				/* @__PURE__ */ h("div", {
					className: "flex center justify-center mt-0.5",
					children: /* @__PURE__ */ h("p", {
						className: "font-semibold",
						children: "-"
					})
				}),
				/* @__PURE__ */ h(D, { onSelection: t })
			]
		}),
		/* @__PURE__ */ g("div", {
			className: "flex",
			children: [/* @__PURE__ */ h(w, {}), /* @__PURE__ */ h(T, {})]
		})
	]
}), S = () => {
	let { previousYear: e } = l(c);
	return /* @__PURE__ */ h(f.IconButton, {
		size: "xs",
		variant: "ghost",
		colorScheme: "default",
		icon: "ChevronsLeft",
		"aria-label": "previous-year-button",
		id: "previous-year-button",
		onClick: e
	});
}, C = () => {
	let { previousMonth: e } = l(c);
	return /* @__PURE__ */ h(f.IconButton, {
		size: "xs",
		variant: "ghost",
		colorScheme: "default",
		icon: "ChevronLeft",
		id: "previous-month-button",
		"aria-label": "previous-month-button",
		onClick: e
	});
}, w = () => {
	let { nextMonth: e } = l(c), i = l((e) => e);
	return o(i, (e) => {
		let i = t(e);
		if (i) {
			let [e, t] = i.split("-"), n = parseInt(t), a = parseInt(e);
			n = parseInt(t + "") + 1, n === 13 && (n = 1, a = parseInt(e + "") + 1), i = `${a}-${r(n)}-01`;
		}
		return n(i);
	}), /* @__PURE__ */ h(f.IconButton, {
		size: "xs",
		variant: "ghost",
		colorScheme: "default",
		icon: "ChevronRight",
		id: "next-month-button",
		"aria-label": "next-month-button",
		onClick: e
	});
}, T = () => {
	let { nextYear: e } = l(c), t = l((e) => e), n = o(t, (e) => v(e).add(1, "year").format("YYYY-MM-DD"));
	return /* @__PURE__ */ h(f.IconButton, {
		size: "xs",
		icon: "ChevronsRight",
		variant: "ghost",
		colorScheme: "default",
		id: "next-year-button",
		"aria-label": "next-year-button",
		disabled: n,
		onClick: e
	});
}, E = ({ onSelection: e }) => {
	let { goToMonthView: t } = l(c), { primaryMonth: n } = k();
	return /* @__PURE__ */ h("button", {
		className: "p-1 rounded-sm hover:bg-muted text-foreground text-xs font-medium cursor-pointer transition-all duration150 ease-linear",
		onClick: () => {
			t(), e?.();
		},
		children: n
	});
}, D = ({ onSelection: e }) => {
	let { goToYearView: t } = l(c), { primaryYear: n } = k();
	return /* @__PURE__ */ h("button", {
		className: "p-1 rounded-sm hover:bg-muted text-foreground text-label font-medium cursor-pointer transition-all duration150 ease-linear",
		onClick: () => {
			t(), e?.();
		},
		children: n
	});
}, O = (t) => {
	let n = e(t), r = a(n.isNepali), i = u();
	i.push(r.setGridDatesWithMeta);
	let { next: o } = i.execute({ next: n });
	return o.gridDatesWithMeta;
}, k = () => {
	let e = l(s);
	return m(() => O(e), [e]);
}, A = (e) => `${e.workingYear}-${r(e.workingMonth)}-${r(e.workingDay)}`, j = ({ onSelection: e, onWeekSelection: t }) => {
	let n = l((e) => e.ctx.showSecondaryDate), r = l((e) => e.ctx.mode), { gridDates: i } = k(), { selectDate: a, selectWeek: o } = l(c), s = r === d.WEEK;
	return /* @__PURE__ */ g("table", {
		className: "w-full text-sm border-separate border-spacing-y-1 border-spacing-x-0",
		children: [/* @__PURE__ */ h("thead", {
			className: "",
			children: /* @__PURE__ */ h(b, {})
		}), /* @__PURE__ */ h("tbody", {
			className: "p-0",
			children: i.map((i, c) => /* @__PURE__ */ h("tr", {
				className: p("p-0", { group: s }),
				children: i.map((c, l) => {
					let u = l === 0, f = l === i.length - 1, m = p("p-1 cursor-pointer text-center transition-colors", s ? {
						"group-hover:bg-primary/15": !c.isSelected,
						"rounded-l-md": u,
						"rounded-r-md": f
					} : "rounded-md hover:bg-muted", {
						"opacity-40 cursor-not-allowed hover:bg-transparent group-hover:bg-transparent": c.isDisabled,
						"bg-secondary text-muted-foreground": c.isToday,
						"bg-primary text-white hover:bg-primary": c.isSelected
					});
					return /* @__PURE__ */ h("td", {
						className: "overflow-hidden",
						onClick: () => {
							if (c.isDisabled) return;
							let n = A(c);
							r === d.WEEK ? (o(n), e?.(n), t?.({
								startDate: A(i[0]),
								endDate: A(i[i.length - 1])
							})) : (a(n), e?.(n), t && t({
								startDate: A(i[0]),
								endDate: A(i[i.length - 1])
							}));
						},
						children: /* @__PURE__ */ g("div", {
							"aria-label": "cell",
							className: m,
							children: [/* @__PURE__ */ h("p", {
								className: "text-xs font-medium",
								children: c.primaryDay
							}), /* @__PURE__ */ h(_, {
								condition: n && c.secondaryDay,
								children: /* @__PURE__ */ h("p", {
									className: "text-xs text-muted-foreground",
									children: c.secondaryDay
								})
							})]
						})
					}, `week-day-${l}`);
				})
			}, `week-row-${c}`))
		})]
	});
}, M = ({ children: e }) => e;
M.Grid = j, M.Control = x;
export { M as CalendarView };

//# sourceMappingURL=calendar-view.js.map